module.exports = __webpack_public_path__ + "img/wmsp.0e6c24f4.jpg";